import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import { addPrivacyPolicy, addTermsCondition, getPrivacyPolicy, getTermsCondition } from "../../../api";
import { snackActions } from "../../../helpers/SnackUtilsConfigurator";


const PrivacyPolicy = () => {
  const [bodyText, setBodyText] = useState("");
  const {
    data: privacyPolicyData,
  } = useQuery("privacy", getPrivacyPolicy);

  const {
    mutateAsync: addPrivacyPolicyAPI,
    isLoading: isAddingPrivacy,
  } = useMutation("add-privacy", addPrivacyPolicy);

  useEffect(() => {
    if (privacyPolicyData) {
      setBodyText(privacyPolicyData.data?.description);
    }
  }, [privacyPolicyData]);

  const handleSubmit = async () => {
    let bodyParams = {
      description: bodyText
    }
    let response = await addPrivacyPolicyAPI(bodyParams);
    if (response?.status) {
      snackActions.success(response?.message ?? "Privacy & Policy Updated Successfully!");
    } else {
      snackActions.error(response?.message ?? "Something went wrong!");
    }

  }

  return (
    <div>
      <div className="card mb-5 mb-xl-10 p-14">
        <ReactQuill
          theme="snow"
          placeholder="Write something..."
          modules={PrivacyPolicy.modules}
          formats={PrivacyPolicy.formats}
          style={{ height: "50vh" }}
          value={bodyText}
          onChange={(e) => setBodyText(e)}
        />
        <div className="d-flex justify-content-end">
          <Button variant="primary" style={{ width: "100px", marginTop: "50px" }} onClick={handleSubmit}  disabled={!bodyText || !bodyText?.replace(/<\/?[^>]+(>|$)/g, "")} color={!bodyText || !bodyText?.replace(/<\/?[^>]+(>|$)/g, "") ? "disabled" : "success"}>{isAddingPrivacy ? "Loading." : "Submit"}</Button>{' '}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;


PrivacyPolicy.modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    [{ color: [] }],
  ],
};
PrivacyPolicy.formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
];